import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';
import { Usuario } from '../modelos/usuario';
import { environment } from 'src/environments/environment';
import { Perfil } from '../modelos/perfil';
import { Empleado } from '../modelos/empleado';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UsuarioService {
  private urlApi: string = environment.urlAdmin + '/usuarios';
  private urlper: string = environment.urlAdmin + '/perfiles';
  private urlPue: string = environment.urlAdmin + '/puesto';
  private urlEmp: string = environment.urlAdmin + '/empleados';
  private urlLoginEmpleado: string = environment.urlAdmin + '/usuarios';
  private urlFirma: string = environment.urlFirmasDig;

  #usuariosSubject = new BehaviorSubject<Usuario[]>([]);
  #empleadosSubject = new BehaviorSubject<Empleado[]>([]);
  #puestosSubject = new BehaviorSubject<Perfil[]>([]);

  constructor(private http: HttpClient) {
    merge(
      this.http.get<Usuario[]>(this.urlApi).pipe(
        tap((usuarios) => {
          this.#usuariosSubject.next(usuarios);
        }),
      ),
      this.http.get<Empleado[]>(this.urlEmp).pipe(
        tap((empleados) => {
          this.#empleadosSubject.next(
            empleados.filter((empleado) => !(empleado.estatus === 'DUPLICADO')),
          );
        }),
      ),
      this.http.get<Perfil[]>(`${this.urlPue}/OrderByNombre`).pipe(
        tap((puestos) => {
          this.#puestosSubject.next(puestos);
        }),
      ),
    ).subscribe(() => {});
  }

  getFirmaDigital(username: String): Observable<Blob> {
    return this.http.get(`${this.urlFirma}/${username}`, {
      responseType: 'blob',
    });
  }

  getUsernamePrueba(username: String): Observable<Usuario> {
    const value = this.#usuariosSubject.value.find(
      (usuario) => usuario.username === username,
    );

    return value
      ? of(value)
      : this.http.get<Usuario>(`${this.urlApi}/${username}/username`);
  }

  getAll() {
    return this.#usuariosSubject.asObservable();
  }

  getAllPuesto() {
    return this.#puestosSubject.asObservable();
  }

  getAnPuesto(id: number): Observable<Perfil> {
    const value = this.#puestosSubject.value.find(
      (puesto) => puesto.idPuesto === id,
    );
    return value ? of(value) : this.http.get<Perfil>(`${this.urlPue}/${id}`);
  }

  getAllEmpleados() {
    return this.#empleadosSubject.asObservable();
  }

  getAnEmpleado(id: number) {
    const value = this.#empleadosSubject.value.find(
      (empleado) => empleado.idEmpleado === id,
    );
    return value ? of(value) : this.http.get<Empleado>(`${this.urlEmp}/${id}`);
  }

  getAllEmpleadosNombre(nombre: string) {
    return this.http.get<Empleado[]>(`${this.urlEmp}/nombre/${nombre}`);
  }

  actualizarFolioIne(id: number, folioIne: string) {
    return this.http
      .put(
        `${this.urlEmp}/actualizar/folio-ine/${id}`,
        {},
        {
          params: {
            folioIne,
          },
        },
      )
      .pipe(
        tap(() => {
          const empleados = this.#empleadosSubject.value;
          const index = empleados.findIndex(
            (empleado) => empleado.idEmpleado === id,
          );
          if (index > -1) {
            empleados[index].folioIne = folioIne;
            this.#empleadosSubject.next(empleados);
          }
        }),
      );
  }
}
